module.exports = __webpack_public_path__ + "static/media/10.fcf4c03c.jpg";